import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { inviteResource } from './invite.resource';

export const invitePreviewQuery = (token: string) =>
  queryOptions({
    queryKey: ['invites', token],
    queryFn: () => inviteResource.preview(token),
    select: (data) => data.invite,
    retry: false,
  });

export function useInvitePreview(token: string) {
  return useQuery(invitePreviewQuery(token));
}

export function useAcceptInvite() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (token: string) => inviteResource.accept(token),
    onSuccess: () => client.invalidateQueries({ queryKey: ['organizations'] }),
  });
}
